import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  assignRoomFailure,
  //
  assignRoomSuccess,
  deleteAssignedRoomFailure,
  //
  deleteAssignedRoomSuccess,
  editAssignRoomFailure,
  //
  editAssignRoomSuccess,
  fetchAssignedRoomFailure,
  fetchAssignedRoomSuccess,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_ASSIGNED_ROOM,
  DELETE_ASSIGNED_ROOMS,
  EDIT_ASSIGNED_ROOM,
  FETCH_ASSIGNED_ROOMS,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchAssignedRoomSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/residence-care-room?${query}`,
    );
    yield put(fetchAssignedRoomSuccess(data));
  } catch (e) {
    yield put(fetchAssignedRoomFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching assigned rooms!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/residence/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addRoomSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const body =
      payload?.type != null
        ? {
            type: payload.type,
            resident_id: payload.resident_id,
            care_room_id: payload.care_room_id,
            start_date: payload.start_date,
            transfer_date: payload.transfer_date,
            end_date: payload.end_date,
            notes: payload.notes,
          }
        : {
            type: "assign",
            resident_id: payload?.resident_id,
            care_room_id: payload?.care_room_id,
            start_date: payload?.start_date,
            notes: payload?.notes,
          };

    const data = yield call(
      api(token).post,
      `/api/residence-care-room/manage`,
      body,
    );
    if (data) {
      const result = data?.data ?? data;
      const defaultMessages = {
        assign: "Room assigned successfully!",
        transfer: "Room transferred successfully!",
        checkout: "Room checkout successful",
      };
      const type = body?.type || "assign";
      yield put(
        successAlert(
          (typeof data?.message === "string" && data.message) ||
            defaultMessages[type] ||
            defaultMessages.assign,
        ),
      );
      yield put(assignRoomSuccess(result));
      typeof onSuccess === "function" && onSuccess(result);
      typeof payload?.onSuccess === "function" && payload.onSuccess(result);
    }
  } catch (e) {
    yield put(assignRoomFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (typeof e.message === "string") yield put(errorAlert(e.message));
  }
}

export function* editRoomSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/residence-care-room/edit/${payload.id}`,
      payload,
    );
    if (data) {
      yield put(successAlert("Details updated successfully!"));
      yield put(editAssignRoomSuccess());
    }
  } catch (e) {
    yield put(editAssignRoomFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteRoomSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/residence-care-room/${payload?.id}`,
    );
    if (data) {
      yield put(successAlert("Room unassigned successfully!"));
      yield put(deleteAssignedRoomSuccess());
    }
  } catch (e) {
    yield put(deleteAssignedRoomFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchAssignedRoomFlow() {
  yield takeEvery(FETCH_ASSIGNED_ROOMS, fetchAssignedRoomSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addRoomFlow() {
  yield takeEvery(ADD_ASSIGNED_ROOM, addRoomSaga);
}
export function* editRoomFlow() {
  yield takeEvery(EDIT_ASSIGNED_ROOM, editRoomSaga);
}
export function* deleteRoomFlow() {
  yield takeEvery(DELETE_ASSIGNED_ROOMS, deleteRoomSaga);
}

export default function* RoomSaga() {
  yield all([
    fetchAssignedRoomFlow(),
    getViewDataFlow(),
    addRoomFlow(),
    editRoomFlow(),
    deleteRoomFlow(),
  ]);
}
